<label class="container" [class.disabled]="disabled">
	<input type="checkbox" [attr.disabled] = "disabled ? 'disabled' : null" [checked]="checked" (click)="valueChanged()">
	<span class="checkmark"></span>
	<span class="label"><ng-content></ng-content></span>
</label>
